// https://vuex.vuejs.org/en/getters.html

export default {
  //
  getTheme(state) {
    return state.theme;
  },
  error(state) {
    return state.error;
  },
  success(state) {
    return state.success;
  },
  delete(state) {
    return state.delete;
  },
  loading(state) {
    return state.loading;
  },
  // theme(state){
  //   return state.website.theme;
  // }
};
